import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Order } from 'src/app/models/order';
import { Travel } from 'src/app/models/travel';
import { TravelService } from 'src/app/services/travel.service';

@Component({
  selector: 'app-calendar-card',
  templateUrl: './calendar-card.component.html',
  styleUrls: ['./calendar-card.component.css']
})
export class CalendarCardComponent implements OnInit {

  @Input() orders:Order[] = [];
  @Input() day:Date;
  @Input() active:boolean = false;
  @Output() selectOrder = new EventEmitter<Order>();
  
  constructor() { }

  ngOnInit() {
  }

  sendOrder(order:Order) {
    this.selectOrder.emit(order);
  }

}
